import { render, staticRenderFns } from "./shopPaySourceParamsList.vue?vue&type=template&id=0af7b112"
import script from "./shopPaySourceParamsList.vue?vue&type=script&lang=js"
export * from "./shopPaySourceParamsList.vue?vue&type=script&lang=js"
import style0 from "./shopPaySourceParamsList.vue?vue&type=style&index=0&id=0af7b112&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports